import { type JSX } from "react";

import { useCustomerContext } from "../../../Context/CustomerContext";
import { useCustomerIntegrations } from "../../../Pages/CloudAnalytics/utilities";
import { useIsEntitledToCurrentDashboardType } from "../hooks/useIsEntitledByDashboardType";
import { Loader } from "../Loader";
import { IntegrationEntitlement } from "./IntegrationEntitlement";

type IntegrationGuardProps = {
  children: JSX.Element;
  integrationName: string;
};

export const IntegrationGuard = ({ children, integrationName }: IntegrationGuardProps) => {
  const isEntitled = useIsEntitledToCurrentDashboardType();
  const { customerIntegrations, loading } = useCustomerIntegrations();
  const { customer } = useCustomerContext();

  if (loading || !customerIntegrations) {
    return <Loader />;
  }

  if (customer.presentationMode?.enabled || customer.presentationMode?.isPredefined) {
    return children;
  }

  const hasIntegration = customerIntegrations.includes(integrationName);

  if (isEntitled && hasIntegration) {
    return children;
  }

  return <IntegrationEntitlement state={isEntitled ? "activate" : "upgrade"} integrationName={integrationName} />;
};
